export enum RouteExperiments {
  AdsBanner = 'logistics-frontend_route_ads_banner',
}

export type RouteConfigs = {
  [RouteExperiments.AdsBanner]?: {
    enabled: boolean
  }
}
